const isMobile = function (screenWidth = window.innerWidth) {
  if (screenWidth <= 1024) {
    return true;
  }
  return false;
};

export default isMobile;